import { useDimensions } from "../../../hooks/useDimensions";
import { getImage } from "../../../services/image-utils";
import "./sectionTitle.scss";
import { Image } from "antd";

interface Props {
  children?: React.ReactNode;
  sectionName?: string;
  logo?: boolean;
}

export default function SectionTitle(props: Props) {
  const { width } = useDimensions();
  const logo = getImage("/assets/SEABC_Logo.png");

  return (
    <div
      className={`bg-blue-50 flex items-center justify-center py-12 ${width <= 500 ? "px-4 py-8" : undefined}`}
      style={{ boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 2px 0px" }}
    >
      {props.sectionName ? (
        <div className="flex gap-4 items-center">
          {props.logo && <Image width={50} preview={false} src={logo} />}
          <h1 className="text-3xl m-0 font-normal">{props.sectionName}</h1>
        </div>
      ) : (
        props.children
      )}
    </div>
  );
}
